export const EXPORT_PROGRESS_EVENT = '.events'

export const getExportChannelName = (programId) => {
  return `export-progress.${programId}`
}
